import React from 'react';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import { useFeatureFlags } from 'components/shared/hooks';
import RadioFieldGroup from 'components/shared/RadioFieldGroup';
import RadioField from 'components/shared/RadioFieldGroup/RadioField';
import classNames from 'classnames';

const RsvpType = ({ onChange, value, className }) => {
  const hasEventsMandatory = useFeatureFlags(['learning_events_mandatory']);
  return (
    <div
      className={classNames({
        'mb-40': hasEventsMandatory && className,
        'NewEventForm-sessionForm mb-24': !hasEventsMandatory && className,
      })}
    >
      <div className="mb-8">
        {hasEventsMandatory
          ? t('in_person_training.new_event.rsvp_label_mandatory')
          : t('in_person_training.new_event.rsvp_label')}
      </div>
      <RadioFieldGroup
        className="ml-12"
        name="rsvpTypeOptions"
        selectedValue={value}
        onChange={onChange}
      >
        <RadioField
          value="single"
          pendoClassName="trk_input_learning_attend-single"
        >
          {hasEventsMandatory
            ? t(
                'in_person_training.new_event.rsvp_radio_single_label_mandatory',
              )
            : t('in_person_training.new_event.rsvp_radio_single_label')}
          <Text variant={TEXT_VARIANTS.BODY_LIGHT} component="div">
            <span className="fz-14">
              {t('in_person_training.new_event.rsvp_radio_single_option')}
            </span>
          </Text>
        </RadioField>
        <RadioField value="all" pendoClassName="trk_input_learning_attend-all">
          {hasEventsMandatory
            ? t('in_person_training.new_event.rsvp_radio_all_label_mandatory')
            : t('in_person_training.new_event.rsvp_radio_all_label')}
          <Text variant={TEXT_VARIANTS.BODY_LIGHT} component="div">
            <span className="fz-14">
              {t('in_person_training.new_event.rsvp_radio_all_option')}
            </span>
          </Text>
        </RadioField>
      </RadioFieldGroup>
    </div>
  );
};

export default RsvpType;
